import { PropertyAutoCalculateTypes,PropertyFormatIdentifier } from "../../constants/propertyFormats";
import toCamelCase from "../../utils/toCamelCase";

const propertyFormatForOldType = t => {
  switch (t) {
    case "number":
      return PropertyFormatIdentifier.integer;
    case "decimal":
      return PropertyFormatIdentifier.double;
    default:
      return t;
  }
};

const propertyAutoCalculateTypeForOldType = (v2propertyAutoCalculateType, v2Type) => {
  switch (v2propertyAutoCalculateType) {
    case "avg":
      return v2Type === PropertyFormatIdentifier.percentage
        ? PropertyAutoCalculateTypes.PROPERTY_AUTO_CALCULATE_TYPE_PERCENTAGE_AVG
        : PropertyAutoCalculateTypes.PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_AVG;
    case "sum":
      return PropertyAutoCalculateTypes.PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_SUM;
    case "max":
      return PropertyAutoCalculateTypes.PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_MAX;
    case "min":
      return PropertyAutoCalculateTypes.PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_MIN;
    case "all":
      return PropertyAutoCalculateTypes.PROPERTY_AUTO_CALCULATE_TYPE_BOOLEAN_ALL;
    case "any":
      return PropertyAutoCalculateTypes.PROPERTY_AUTO_CALCULATE_TYPE_BOOLEAN_ANY;
    case "weightedPercentage":
      return PropertyAutoCalculateTypes.PROPERTY_AUTO_CALCULATE_TYPE_PERCENTAGE_WEIGHTED;
    default:
      return v2propertyAutoCalculateType;
  }
};

export default v2Property => {
  let allowed = null;
  if (v2Property.type === "list") {
    allowed = [];
    v2Property.listOptions.forEach(listOption => {
      const opt = { id: listOption.guid, label: listOption.option };
      allowed.push(opt);
    });
  }
  return {
    id: v2Property.guid,
    key: toCamelCase(v2Property.name),
    format: propertyFormatForOldType(v2Property.type),
    allowed,
    multiple: false,
    label: v2Property.name,
    canDelete: false,
    autoCalculate: v2Property.calculate,
    autoCalculateType: propertyAutoCalculateTypeForOldType(v2Property.calcMode, v2Property.type),
    indicateItemCompletion: v2Property.fadeEvents
  };
};
